import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import ConditionalTooltip from '../conditionalTooltip';
import { ReactComponent as RequestIcon } from '../../../assets/icons/back_hand.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: primary.bluish8,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(0.5, 1),
    width: 24,
    height: 24,
  },
  tooltip: {
    display: 'flex',
    flexShrink: 0,
  },
}));

const RequestedIconTooltip = ({
  className = undefined,
  labels,
  isRequestedByCurrentUser = false,
}) => {
  const classes = useStyles();

  return (
    <ConditionalTooltip
      className={classNames(classes.tooltip, className)}
      message={
        isRequestedByCurrentUser ? labels.requestedByYou : labels.default
      }
      addTooltip
    >
      <div className={classes.root}>
        <RequestIcon />
      </div>
    </ConditionalTooltip>
  );
};

RequestedIconTooltip.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.object.isRequired,
  isRequestedByCurrentUser: PropTypes.bool,
};

export default RequestedIconTooltip;
